import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbAzure: BowlBlock = withIntegration(options.slug.llmKbAzure, [
  {
    name: 'remoteUrl',
    type: 'withText',
    required: true,
  },
  {
    name: 'accountName',
    type: 'withText',
    required: true,
  },
  {
    name: 'accountKey',
    type: 'withText',
  },
  {
    name: 'connectionString',
    type: 'withText',
  },
  {
    name: 'sasToken',
    type: 'withText',
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
